var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "printer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.757,
    viewBox: "0 0 16 14.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M14.871,13.043H13.079V10.117a.484.484,0,0,0-.484-.484H3.4a.484.484,0,0,0-.484.484v2.926H1.129A1.13,1.13,0,0,0,0,14.172v6.207a1.13,1.13,0,0,0,1.129,1.129H2.921v2.4a.484.484,0,0,0,.484.484H12.6a.484.484,0,0,0,.484-.484v-2.4h1.792A1.13,1.13,0,0,0,16,20.378V14.172A1.13,1.13,0,0,0,14.871,13.043ZM3.888,10.6h8.223v2.442H3.888Zm8.223,12.822H3.888v-4.8h8.223Zm2.921-3.045a.163.163,0,0,1-.161.161H13.079v-2.4a.484.484,0,0,0-.484-.484H3.4a.484.484,0,0,0-.484.484v2.4H1.129a.163.163,0,0,1-.161-.161V14.172a.163.163,0,0,1,.161-.161H14.871a.163.163,0,0,1,.161.161v6.207Z",
    transform: "translate(0 -9.633)",
    fill: "#1450ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(11.907 5.512)",
    fill: "#1450ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M87.293,163.822h-4.4a.484.484,0,1,0,0,.967h4.4a.484.484,0,1,0,0-.967Z",
    transform: "translate(-77.092 -153.877)",
    fill: "#1450ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M87.293,193.623h-4.4a.484.484,0,1,0,0,.968h4.4a.484.484,0,0,0,0-.968Z",
    transform: "translate(-77.092 -181.755)",
    fill: "#1450ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print-icon.3f6d9c1903ec901284b6040a95040673.svg";
export { ForwardRef as ReactComponent };